import React from 'react';
import { Modal as UIModal, ButtonToolbar } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Button from './Button';

interface Props {
  title?: string;
  titleUnderline?: boolean;
  actions?: ModalAction[];
  visible: boolean;
  close?: () => void;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  noThirdStyle?: boolean;
  children: React.ReactNode;
  size?: string;
  onClosed?: () => void;
  customClass?: string;
}

interface ModalAction {
  text: string;
  icon?: IconProp;
  action?: () => void;
  noClose?: boolean;
  className?: string;
  disabled?: boolean | undefined;
}

const Modal: React.FC<Props> = (props: Props) => {
  const {
    title,
    titleUnderline,
    actions,
    visible,
    close = () => {},
    setVisible,
    noThirdStyle = false,
    children,
    size,
    onClosed = () => {},
    customClass = null,
  } = props;

  const onClose = setVisible ? () => setVisible(false) : () => close();
  const execute = (action?: () => void, noClose = false) => {
    if (action) {
      action();
    }
    if (!noClose) {
      onClose();
    }
  };

  const buttonDiv = (modalAction: ModalAction, ix: number) => {
    if (!actions) {
      return null;
    }
    const { action, text, icon } = modalAction;
    let className = noThirdStyle ? 'btn-secondary' : 'btn-tertiary';
    if (ix > 0) {
      className = ix === actions.length - 1 ? 'btn-primary' : 'btn-secondary';
    }
    if (modalAction.className) {
      className = modalAction.className;
    }

    return (
      <Button
        key={`a${ix}`}
        icon={icon}
        className={className}
        onClick={() => execute(action, modalAction.noClose)}
        text={text}
        type="button"
        disabled={modalAction.disabled}
      />
    );
  };

  let classes = actions ? 'modal__body theme-light' : '';
  if (classes) {
    classes += title ? '' : ' notitle';
  }

  const content = (
    <>
      <div className={classes}>{children}</div>
      {actions && (
        <ButtonToolbar className="modal__footer w-100">
          {actions.map((a, ix) => buttonDiv(a, ix))}
        </ButtonToolbar>
      )}
    </>
  );

  return (
    <div>
      <UIModal
        isOpen={visible} // it will never toogle from false to true (see online docs)
        toggle={onClose}
        onClosed={onClosed}
        size={size}
        className={`modal-dialog--primary modal-dialog--header ${customClass || ''}`}
      >
        <div className="modal__header">
          <button className="modal__close-btn" type="button" onClick={onClose}>
            <FontAwesomeIcon icon="times" />
          </button>
          {title && (
            <h4 className={`bold-text modal__title ${titleUnderline ? 'title-underline' : ''}`}>
              {title}
            </h4>
          )}
        </div>
        {content}
      </UIModal>
    </div>
  );
};

export default Modal;
